<template>
  <div>
    <NavBar />
    <Header />
    <v-container class="pa-0">
      <Banner :slides="banners"/>

      <channel v-if="channelsAvailable" :channels="channels"/>

      <v-divider></v-divider>
      <v-row class="my-10 px-md-3">
        <v-col cols="12" md="8" class="indigo lighten-2"> <PostList :posts="posts" /> </v-col>
        <v-col cols="12" md="4" class="grey darken-2"> <CreatePost /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Header from "@/components/Header.vue";
import Banner from "@/components/home/Banner.vue";
import Channel from '@/components/home/Channel.vue';
import PostList from '@/components/post/PostList.vue';
import CreatePost from '@/components/post/CreatePost.vue';

import { getBanners, getChannels, getPosts } from '../api/public';
import { bus } from '../main';

export default {
  components: {
    NavBar,
    Header,
    Banner,
    Channel,
    PostList,
    CreatePost
  },
  data() {
    return {
      banners: [],
      channels: [],
      channelsAvailable: false,
      posts: []
    };
  },
  async mounted() {
    let res = await getBanners();
    if (res.status == '1') {
      this.banners = res.data;
    } else {
      console.log( res?.msg || 'No banners found.' );
    }

    let resp = await getChannels();
    if (resp.status == '1') {
      this.channels = resp.data;
      this.channelsAvailable = true;
    } else {
      this.channelsAvailable = false;
      console.log(resp?.msg || 'No channels available.');
    }

    await this.fetchPosts();
  },
   created() {
    bus.$on('newPost', async () => {
      await this.fetchPosts();
      bus.$off();
    })
  },
  methods: {
    async fetchPosts() {
      let postRes = await getPosts();
      if (postRes.status == '1') {
      this.posts = postRes.data;
    }
    }
  }
};
</script>

<style></style>
